import {
  ErrorMessage,
  InputField,
} from 'anf-core-react';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import Tmnt from '../../../Tmnt/Tmnt';

const textProp = PropTypes.shape({
  key: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
});

export const propTypes = {
  error: textProp,
  label: textProp.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  isDisabled: PropTypes.bool,
  isInvalid: PropTypes.bool,
  isRequired: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  type: PropTypes.string,
  id: PropTypes.string,
  maxLength: PropTypes.number,
};

const defaultProps = {
  value: '',
  isDisabled: false,
  isInvalid: false,
  isRequired: false,
  onChange: undefined,
  onBlur: undefined,
  type: 'text',
  maxLength: undefined,
  id: undefined,
  error: undefined,
};

export default function AddressInput({
  value,
  error,
  type,
  isDisabled,
  isInvalid,
  isRequired,
  label,
  maxLength,
  name,
  id,
  onChange,
  onBlur,
}) {
  const inputId = id ?? `address-field-input-${name}`;

  const errorTmnt = useMemo(() => {
    if (!error) return null;

    if (!error.value?.includes('{0}')) return error;

    return {
      ...error,
      value: error.value?.replace('{0}', label?.value?.toLowerCase())
        .replace('{1}', '')
        .replace('zip', 'ZIP'),
    };
  }, [error, label]);

  const errorMessage = useMemo(() => {
    if (!isInvalid || !error) return null;

    return (
      <ErrorMessage id={`${id}-error-message`} variant="error">
        <Tmnt tmnt={errorTmnt} />
      </ErrorMessage>
    );
  }, [error, isInvalid, id, errorTmnt]);

  return (
    <InputField
      autoComplete="off"
      id={inputId}
      isDisabled={isDisabled}
      isInvalid={isInvalid}
      isRequired={isRequired}
      label={label?.value}
      maxLength={maxLength}
      name={name}
      onChange={onChange}
      type={type}
      value={value}
      onBlur={onBlur}
    >
      {errorMessage}
    </InputField>
  );
}

AddressInput.propTypes = propTypes;
AddressInput.defaultProps = defaultProps;
